export const transportTypes = [
  'TRAIN',
  'FERRY',
  'BUS',
  'OTHER_TRANSPORT',
] as const

export const nonSimpleMoveItemTypes = [
  'FLIGHT',
  ...transportTypes,
  'CAR_RENTAL',
] as const
